import React from 'react';
import { withStyles } from 'tss-react/mui';
import { connect } from 'react-redux';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { List } from 'immutable';

import CustomImg from '../Utils/CustomImg';

const getImages = (merge) => {
  if (merge){
    const images = (merge.getIn(['elem', 'obj', 'images'],
      new List()) || new List()).map(e => ({
      photo: e,
      caption: merge.getIn(['elem', 'obj', 'title'], ''),
      subcaption:
        `${( merge.getIn([
          'elem', 'obj', 'description'], '') || '' ).substring(0, 100)} ...`,
      thumbnail: e
    })).toJS();
    if ((merge.getIn(['elem', 'obj', 'img'], undefined) || undefined )){
      images.unshift(
        {
          photo: merge.getIn(['elem', 'obj', 'img']),
          caption: merge.getIn(['elem', 'obj', 'title'], ''),
          subcaption:
            `${( merge.getIn([
              'elem', 'obj', 'description'], '') || '' )
              .substring(0, 100)} ...`,
          thumbnail: merge.getIn(['elem', 'obj', 'img'])
        });
    }
    return images;
  }
  return undefined;
};


const mapStateToProps = ({
  dialog: { contentProps: { merge } }
}) => ({ merge });


const styles = () => ({
  textStyle: {
    alignSelf: 'center',
    textAlign: 'center'
  },
  padding: {
    paddingTop: 10
  },
  group: {
    display: 'block',
    textAlign: 'center'
  }
});

const ImageListDialog = ({ merge }) => (
  <ImageList cols={1} rowHeight="auto">
    {getImages(merge).map((item) => (
      <ImageListItem key={item.photo}>
        <CustomImg src={item.photo} alt={item.caption} />
      </ImageListItem>
    ))}
  </ImageList>

);

export default connect(mapStateToProps)(withStyles(ImageListDialog, styles));
